import { withOneTrust } from '@segment/analytics-consent-wrapper-onetrust';
import { AnalyticsBrowser } from '@segment/analytics-next';

const writeKey = process.env.NEXT_PUBLIC_SEGMENT_WRITE_KEY!;

export const analytics = new AnalyticsBrowser();

if (typeof window !== 'undefined') {
  withOneTrust(analytics).load({ writeKey });
} else {
  analytics.load({ writeKey });
}
